<template>
  <div class="card-item base-info-card">
    <div class="title-box">
      <span class="title-text">工作室基本信息</span>
      <span class="btn-action-group"> </span>
    </div>
    <div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 工作室名称
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              placeholder="请输入工作室名称"
              :maxLength="100"
              v-model="info.name"
              :disabled="isEdit || !isbj"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 申报年份
          </div>
          <!-- :disabled="isEdit || !isbj" -->
          <div class="pl16">
            <a-date-picker
              placeholder="请选择申报年份"
              v-model="info.applyYear"
              :disabled="isEdit"
              :open="yearShowOne"
              :locale="locale"
              :format="'YYYY'"
              mode="year"
              @openChange="openChangeOne"
              @panelChange="panelChangeOne"
              class="form-item-right"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item" style="width: 100%;">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 工作室地点
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              :maxLength="50"
              placeholder="请输入工作室地点"
              v-model="info.address"
              :disabled="isEdit"
            />
            <!--  -->
          </div>
        </div>
      
      </div>
      <div class="mt30">
          <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 场所面积
          </div>
          <div class="pl16 plflex">
            <a-input
              class="input-style-2"
              type="text"
              pattern="[1-9]\d*"
              placeholder="请输入场所面积"
              v-model="info.acreage"
              style="width: 86%"
              :disabled="isEdit"
            />
            <span class="text2">平米</span>
          </div>
          <!-- -->
        </div>
         <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 建设日期
          </div>
          <div class="pl16">
            <a-date-picker
              placeholder="请选择建设日期"
              v-model="info.foundTime"
              :disabled="isEdit"
              :format="'YYYY-MM-DD'"
              :locale="locale"
              class="form-item-right"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item" style="width: 100%;">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 所属部门
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              placeholder="请输入所属部门"
              :maxLength="100"
              v-model="info.belongDepartment"
              :disabled="isEdit"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>全校师生对工作室知晓度
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.tsSzgzsKnow"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <span class="text2">%</span>
          </div>
        </div>

        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>全校师生对工作室服务满意度
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.tsSzgzsSatisfied"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <span class="text2">%</span>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>项目被省级或国家级媒体报道次数
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.reportNum"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <span
              class="percentage-sign"
              v-if="info.id"
              @click="showevidence(0)"
              >佐证</span
            >
          </div>
        </div>

        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>省内外同类院校前来交流学习次数
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.conmunicateNum"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <span
              class="percentage-sign"
              v-if="info.id"
              @click="showevidence(1)"
              >佐证</span
            >
          </div>
        </div>
      </div>
      <!--<div class="mt30">
        <div>
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 联系电话
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              :maxLength="11"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入联系电话"
              v-model="info.phone"
              :disabled="isEdit"
            />
          </div>
        </div>
      </div>-->
      <!-- <div class="text1">申报书模板下载</div>
        <div class="flex align-items-center">
          <img class="img-box-4" src="../../assets/images/img39.png" alt="" />
          <div class="text2" style="color: #2155B5; cursor: pointer">
            <a
              href="/思政教育工作室项目申报书.docx"
              download="思政微课项目申报书.docx"
              style="color: #2155B5"
            >
              思政教育工作室申报书.docx</a
            >
            <span class="text2">(32.2KB)</span>
          </div>
        </div>
      </div>-->
      <div class="mt30">
        <div class="form-item-upload">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>
            工作室运行状态
          </div>
          <div class="pl16">
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :disabled="isEdit"
              style="margin-bottom: 5px"
              v-model="info.studioStatus"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item-upload">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>
            申报书上传
          </div>
          <div class="pl16">
            <a-upload
              :file-list="fileList"
              :disabled="isEdit"
              :remove="(file, fileList) => handleRemove(file, fileList)"
              :before-upload="(file, fileList) => beforeUpload(file, fileList)"
              accept=".pdf"
              :style="{ cursor: isEdit ? 'pointer' : '' }"
              @preview="handlePreview"
            >
              <a-button :disabled="isEdit || loading" :loading="loading">
                <a-icon type="upload" />上传附件
              </a-button>
              <span class="text2">注：请上传pdf格式的文件</span>
            </a-upload>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item-upload">
          <div class="main-text-style">
            <span style="color: #f6350f"></span>
            建设方案上传
          </div>
          <div class="pl16">
            <a-upload
              :file-list="fileList1"
              :disabled="isEdit"
              :remove="(file, fileList) => handleRemove1(file, fileList)"
              :before-upload="(file, fileList) => beforeUpload1(file, fileList)"
              accept=".pdf"
              :style="{ cursor: isEdit ? 'pointer' : '' }"
              @preview="handlePreview"
            >
              <a-button :disabled="isEdit || loadings" :loading="loadings">
                <a-icon type="upload" />上传附件
              </a-button>
              <span class="text2">注：请上传pdf格式的文件</span>
            </a-upload>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item-upload">
          <div class="main-text-style">
            <span style="color: #f6350f; opacity: 0"></span>
            校方承诺书上传
          </div>
          <div class="pl16">
            <a-upload
              :file-list="letterList"
              :disabled="isEdit"
              :remove="(file, fileList) => handleRemoveLetter(file, fileList)"
              :before-upload="
                (file, fileList) => beforeUploadLetter(file, fileList)
              "
              accept=".pdf"
              :style="{ cursor: isEdit ? 'pointer' : '' }"
              @preview="handlePreview"
            >
              <a-button
                :disabled="isEdit || letterLoading"
                :loading="letterLoading"
              >
                <a-icon type="upload" />上传附件
              </a-button>
              <span class="text2">注：请上传pdf格式的文件</span>
            </a-upload>
          </div>
        </div>
      </div>
      <template v-if="!isEdit || !isbj">
        <div class="submit-btn-box">
          <div class="submit-btn btn-bg-1" @click="saveDraft">暂存</div>
        </div>
      </template>
    </div>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :dataid="dataid"
          :code="code"
          :isEdit="isEdit"
          :id="id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showiframe">
      <div class="preview-boxs" style="height: 90%">
        <newpreview
          :previewUrl="previewUrl"
          @closePreview="showiframe = false"
          :dialogTitle="titlename"
        ></newpreview>
      </div>
    </div>
    <a-modal
      title="确定要保存吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>检测到您修改了基本信息，将进行重新提交审核,您确定要保存吗?</p>
    </a-modal>
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { postAction, putAction, fileUpdate } from "@/api/index";
import { baseURL } from "@/utils/request.js";
import evidencelist from "@/components/common/evidencelist";
import newpreview from "@/components/common/newpreviews";

export default {
  name: "",
  components: { evidencelist, newpreview },
  props: {
    oldInfos: {
      type: Object,
    },
    isAdd: {
      type: Boolean,
    },
    isbj: {
      type: Boolean,
    },
  },
  data() {
    return {
      isEdit: false,
      showDeleteModel: false,
      info: {
        applyType: "1",
        name: "",
        address: "",
        foundTime: "",
        applyYear: "",
        id: "",
        declarationName: "",
        declarationPath: "",
        acreage: "",
        belongDepartment: "",
        tsSzgzsKnow: "",
        tsSzgzsSatisfied: "",
        reportNum: "",
        conmunicateNum: "",
        letterOfCommitmentName: "",
        letterOfCommitmentPath: "",
        studioStatus: true, // true=开(0) false=关(1)，与保存逻辑一致
      },
      dataid: "",
      showtable: false,
      zh_CN,
      locale,
      yearShowOne: false,
      path: baseURL,
      fileList: [],
      fileList1: [],
      letterList: [],
      loading: false,
      loadings: false,
      letterLoading: false,

      title: "",
      id: "",
      code: "",
      showiframe: false,
      previewUrl: "",
      titlename: "",
      // isbj:true,
      isxg: false,
      sj: {},
      updateTaskId: null,
    };
  },
  computed: {},
  watch: {
    oldInfos: {
      handler(newValue, oldValue) {
        console.log(newValue, "9999999999999999");
        if (newValue != null) {
          this.info = newValue;
          this.oldInfos = newValue;
          if (
            this.oldInfos &&
            this.oldInfos.declarationName != "" &&
            this.oldInfos.declarationName != null &&
            this.oldInfos.declarationPath != "" &&
            this.oldInfos.declarationPath != null
          ) {
            this.fileList = [];
            let fileItem = {};
            fileItem.path = this.oldInfos.declarationPath;
            fileItem.name = this.oldInfos.declarationName;
            fileItem.uid = 1;
            this.fileList.push(fileItem);
          }
          if (
            this.oldInfos &&
            this.oldInfos.activityPlanName != "" &&
            this.oldInfos.activityPlanName != null &&
            this.oldInfos.activityPlanPath != "" &&
            this.oldInfos.activityPlanPath != null
          ) {
            this.fileList1 = [];
            let fileItem = {};
            fileItem.path = this.oldInfos.activityPlanPath;
            fileItem.name = this.oldInfos.activityPlanName;
            fileItem.uid = 2;
            this.fileList1.push(fileItem);
          }
          if (
            this.oldInfos &&
            this.oldInfos.letterOfCommitmentName != "" &&
            this.oldInfos.letterOfCommitmentName != null &&
            this.oldInfos.letterOfCommitmentPath != "" &&
            this.oldInfos.letterOfCommitmentPath != null
          ) {
            this.letterList = [];
            let fileItem = {};
            fileItem.path = this.oldInfos.letterOfCommitmentPath;
            fileItem.name = this.oldInfos.letterOfCommitmentName;
            fileItem.uid = 2;
            this.letterList.push(fileItem);
          }
          if (
            this.oldInfos &&
            (this.oldInfos.studioStatus === 0 ||
              this.oldInfos.studioStatus === 1 ||
              this.oldInfos.studioStatus === "0" ||
              this.oldInfos.studioStatus === "1")
          ) {
            // 仅在接口原始值 0/1 时转换；切换后为 boolean，勿再覆盖
            this.info.studioStatus = String(this.oldInfos.studioStatus) === "0";
          }
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
            // 教师角色下， 非负责模块不可编辑
            if (
              this.$store.state.role == "teacher-role" &&
              !this.isStudioModule
            ) {
              this.isEdit = true;
            }
            if (
              this.$store.state.role == "teacher-role" &&
              this.isStudioModule
            ) {
              this.isEdit = false;
            }
          }
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        if (
          this.$route.query.new == "preview" ||
          this.$parent?.news == "preview" ||
          this.$parent?.editInfo?.type == "preview" ||
          this.oldInfos?.type == "preview"
        ) {
          this.isEdit = true;
          return;
        }
        this.isEdit = newValue;
      },
      immediate: true,
    },
    info: {
      handler(newValue, oldValue) {
        console.log(newValue, "222222");
        this.isxg = true;
      },
      deep: true,
    },
  },
  created() {
    // if (this.isAdd) {
    //   this.isEdit = true;
    //   return;
    // }
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
  },
  destroyed() {
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  mounted() {
    // let oldInfo = JSON.parse(
    //   sessionStorage.getItem(`step${this.$store.state.user.id}`)
    // );
    // if (oldInfo) {
    //   this.info.id = oldInfo.id;
    //   this.info.name = oldInfo.name;
    //   this.info.address = oldInfo.address;
    //   this.info.foundTime = oldInfo.foundTime;
    //   this.info.applyYear = oldInfo.applyYear;
    //   this.info.declarationName = oldInfo.declarationName;
    //   this.info.declarationPath = oldInfo.declarationPath;
    //   this.info.acreage = oldInfo.acreage;
    //   this.info.belongDepartment = oldInfo.belongDepartment;
    // }
    this.fileList = [];
    this.fileList1 = [];
    this.letterList = [];
    // console.log(this.oldInfo);
    // if (
    //   oldInfo &&
    //   oldInfo.declarationName != "" &&
    //   oldInfo.declarationName != null &&
    //   oldInfo.declarationPath != "" &&
    //   oldInfo.declarationPath != null
    // ) {
    //   let fileItem = {};
    //   fileItem.path = oldInfo.declarationPath;
    //   fileItem.name = oldInfo.declarationName;
    //   fileItem.uid = 1;
    //   this.fileList.push(fileItem);
    // }
    if (
      this.oldInfos &&
      this.oldInfos.declarationName != "" &&
      this.oldInfos.declarationName != null &&
      this.oldInfos.declarationPath != "" &&
      this.oldInfos.declarationPath != null
    ) {
      this.fileList = [];
      let fileItem = {};
      fileItem.path = this.oldInfos.declarationPath;
      fileItem.name = this.oldInfos.declarationName;
      fileItem.uid = 1;
      this.fileList.push(fileItem);
    }
    if (
      this.oldInfos &&
      this.oldInfos.activityPlanName != "" &&
      this.oldInfos.activityPlanName != null &&
      this.oldInfos.activityPlanPath != "" &&
      this.oldInfos.activityPlanPath != null
    ) {
      this.fileList1 = [];
      let fileItem = {};
      fileItem.path = this.oldInfos.activityPlanPath;
      fileItem.name = this.oldInfos.activityPlanName;
      fileItem.uid = 2;
      this.fileList1.push(fileItem);
    }
    if (
      this.oldInfos &&
      this.oldInfos.letterOfCommitmentName != "" &&
      this.oldInfos.letterOfCommitmentName != null &&
      this.oldInfos.letterOfCommitmentPath != "" &&
      this.oldInfos.letterOfCommitmentPath != null
    ) {
      this.letterList = [];
      let fileItem = {};
      fileItem.path = this.oldInfos.letterOfCommitmentPath;
      fileItem.name = this.oldInfos.letterOfCommitmentName;
      fileItem.uid = 2;
      this.letterList.push(fileItem);
    }
    if (
      this.oldInfos &&
      (this.oldInfos.studioStatus === 0 ||
        this.oldInfos.studioStatus === 1 ||
        this.oldInfos.studioStatus === "0" ||
        this.oldInfos.studioStatus === "1")
    ) {
      // 仅在接口原始值 0/1 时转换；切换后为 boolean，勿再覆盖
      this.info.studioStatus = String(this.oldInfos.studioStatus) === "0";
    }
  },
  methods: {
    showevidence(num) {
      if (num == "0") {
        this.title = "项目被省级或国家级媒体报道次数";
        this.code = "xxbsjhgjjmtbdcs";
      } else {
        this.title = "省内外同类院校前来交流学习次数";
        this.code = "snwtlyxqljlxxcs";
      }
      this.id = this.oldInfos.id;
      this.showtable = true;
    },
    // edit(){
    //     this.isbj=false;
    //     this.isEdit=false;
    //     this.$emit('isbj');
    // },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleRemove1(file, fileList) {
      this.fileLis1t = this.fileList1.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList1.indexOf(file);
      const newFileList = this.fileList1.slice();
      newFileList.splice(index, 1);
      this.fileList1 = newFileList;
    },
    beforeUpload1(file, fileList) {
      this.handleUpload1(file);
      return false;
    },
    handleUpload1(file) {
      if (this.fileList1.length >= 1) {
        this.$message.error("建设方案只能上传一个文件,请移除后再上传");
        return;
      }
      this.loadings = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList1.push(fileItem);
          this.loadings = false;
        } else {
          this.$message.error("上传失败");
          this.loadings = false;
        }
      });
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (file.type != "application/pdf") {
        this.$message.error("请上传规定格式的文件");
        return false;
      }
      if (this.fileList.length >= 1) {
        this.$message.error("申报书只能上传一个文件,请移除后再上传");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
          this.loadings = false;
        }
      });
    },
    handleRemoveLetter(file, fileList) {
      this.letterList = this.letterList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.letterList.indexOf(file);
      const newFileList = this.letterList.slice();
      newFileList.splice(index, 1);
      this.letterList = newFileList;
    },
    beforeUploadLetter(file, fileList) {
      this.handleUploadLetter(file);
      return false;
    },
    handleUploadLetter(file) {
      if (this.letterList.length >= 1) {
        this.$message.error("校方承诺只能上传一个文件,请移除后再上传");
        return;
      }
      this.letterLoading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.letterList.push(fileItem);
          this.letterLoading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    // 得到年份选择器的值
    panelChangeOne(value) {
      this.info.applyYear = value;
      this.yearShowOne = false;
    },
    isBlank(value) {
      if (value === null || value === undefined || value === "") return true;
      if (typeof value === "string" && value.trim() === "") return true;
      return false;
    },
    validateName() {
      if (this.isBlank(this.info && this.info.name)) {
        this.$message.info("请填写工作室名称");
        return false;
      }
      return true;
    },
    validate() {
      if (!this.validateName()) {
        return false;
      }
      if (this.isBlank(this.info && this.info.applyYear)) {
        this.$message.info("请选择申报年份");
        return false;
      }
      if (this.isBlank(this.info && this.info.address)) {
        this.$message.info("请填写工作室地点");
        return false;
      }
      if (this.isBlank(this.info && this.info.acreage)) {
        this.$message.info("请填写思政教育工作室面积");
        return false;
      }
      let telStr = /^(0*[1-9]\d*\.?\d+|[1-9]\d*)$/;
      if (!telStr.test(this.info.acreage)) {
        this.$message.info("输入的思政教育工作室面积格式不正确");
        return false;
      }
      if (this.isBlank(this.info && this.info.belongDepartment)) {
        this.$message.info("请填写思政教育工作室所属部门");
        return false;
      }
      if (this.isBlank(this.info && this.info.foundTime)) {
        this.$message.info("请选择工作室建设日期");
        return false;
      }
      const hasDeclaration =
        (this.fileList &&
          this.fileList.length > 0 &&
          this.fileList[0] &&
          this.fileList[0].path) ||
        (this.info && this.info.declarationPath);
      if (!hasDeclaration) {
        this.$message.info("请上传申报书");
        return false;
      }
      return true;
    },
    buildParams() {
      let formattedDate = "";
      if (this.info && this.info.foundTime) {
        const dateObj = new Date(this.info.foundTime);
        if (!isNaN(dateObj.getTime())) {
          const year = dateObj.getFullYear();
          const month = dateObj.getMonth() + 1;
          const date = dateObj.getDate();
          formattedDate =
            year +
            "-" +
            (month < 10 ? "0" + month : "" + month) +
            "-" +
            (date < 10 ? "0" + date : "" + date);
        }
      }
      let applyYear = "";
      if (this.info && this.info.applyYear) {
        const y = new Date(this.info.applyYear);
        applyYear = isNaN(y.getTime())
          ? String(this.info.applyYear)
          : y.getFullYear() + "";
      }
      const declName =
        this.fileList.length > 0
          ? this.fileList[0].name
          : this.info.declarationName || "";
      const declPath =
        this.fileList.length > 0
          ? this.fileList[0].path
          : this.info.declarationPath || "";
      let params = {
        applyType: this.info.applyType,
        name: this.info.name,
        address: this.info.address,
        foundTime: formattedDate,
        applyYear: applyYear,
        id: this.info.id,
        declarationName: declName,
        declarationPath: declPath,
        acreage: this.info.acreage,
        belongDepartment: this.info.belongDepartment,
        tsSzgzsKnow: this.info.tsSzgzsKnow,
        tsSzgzsSatisfied: this.info.tsSzgzsSatisfied,
        reportNum: this.info.reportNum,
        conmunicateNum: this.info.conmunicateNum,
        activityPlanName: "",
        activityPlanPath: "",
        letterOfCommitmentName: "",
        letterOfCommitmentPath: "",
      };
      this.info.declarationName = declName;
      this.info.declarationPath = declPath;
      if (this.fileList1.length > 0) {
        params.activityPlanName = this.fileList1[0].name;
        params.activityPlanPath = this.fileList1[0].path;
        this.info.activityPlanName = this.fileList1[0].name;
        this.info.activityPlanPath = this.fileList1[0].path;
      }
      if (this.letterList.length > 0) {
        params.letterOfCommitmentName = this.letterList[0].name;
        params.letterOfCommitmentPath = this.letterList[0].path;
        this.info.letterOfCommitmentName = this.letterList[0].name;
        this.info.letterOfCommitmentPath = this.letterList[0].path;
      }
      params.studioStatus = this.info.studioStatus ? "0" : "1";
      return params;
    },
    goStep() {
      return this.save(false);
    },
    saveDraft() {
      if (!this.validateName()) {
        return Promise.reject(new Error("validate"));
      }
      return this.save(true, { silent: true }).then((res) => {
        this.$message.success("暂存成功");
        return res;
      });
    },
    save(skipValidate, options) {
      const silent = options && options.silent;
      if (!skipValidate && !this.validate()) {
        return Promise.reject(new Error("validate"));
      }
      this.isEdit = false;
      this.sj = this.buildParams();
      return this.gosave(silent);
    },
    handleOk() {
      let params = this.sj;
      (this.showDeleteModel = false), (params.checkState = 1);
      postAction("/lx/lxApply/szAdd", params).then((res) => {
        if (res.code == 200) {
          this.$message.success("保存成功");
          this.info.id = res.result.id;
          window.sessionStorage.setItem(
            `step${this.$store.state.user.id}`,
            this.info.id
          );
          this.$emit("goStep", this.info);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    gosave(silent) {
      let params = this.sj;
      if (
        (this.$parent.editInfo?.auditState == "2" &&
          this.sj?.id &&
          this.$parent.editInfo?.nowContent) ||
        this.updateTaskId
      ) {
        let params1 = {
          id: JSON.parse(this.$parent.editInfo?.nowContent)
            ? JSON.parse(this.$parent.editInfo?.nowContent).taskId
            : this.updateTaskId,
          applicationData: JSON.stringify(this.$nullToEmpty(params)),
        };
        return putAction("/audit/lxAuditTask/editTaskAndDetail", params1).then(
          (res) => {
            if (res.code == 200) {
              if (!silent) this.$message.success("保存成功");
              this.$emit("goStep", this.info);
              return res;
            }
            this.$message.error(res.message);
            return Promise.reject(res);
          }
        );
      }
      return postAction("/lx/lxApply/szAdd", params).then((res) => {
        if (res.code == 200) {
          this.updateTaskId = res.result.taskId;
          this.info.id = res.result.id;
          if (res.result.auditState != null && res.result.auditState !== "") {
            this.info.auditState = res.result.auditState;
          } else if (
            this.info.auditState == null ||
            this.info.auditState === ""
          ) {
            this.info.auditState = "0";
          }
          if (!silent) this.$message.success("保存成功");
          window.sessionStorage.setItem(
            `step${this.$store.state.user.id}`,
            this.info.id
          );
          this.$emit("goStep", this.info);
          return res;
        }
        this.$message.error(res.message);
        return Promise.reject(res);
      });
    },
    onClean() {
      this.isEdit = false;
    },
    handlePreview(f) {
      if (this.isEdit) {
        console.log(f, "44444");
        // let url = f.url;
        // let index = url.lastIndexOf(".");
        // let result = url.substring(index + 1);
        // this.fileType = result;
        // if(url && (url.includes('http://') || url.includes('https://'))){
        //   this.fileUrl = f.url;
        // }else{
        //   this.fileUrl= baseURL+f.url;
        // }
        if (f.path != "" && f.path != null) {
          this.titlename = f.name;
          this.showiframe = true;
          this.previewUrl = f.path;
        } else {
          // this.$message.warning("建设总结方案暂未上传，请上传后预览");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.card-item {
  background: #ffffff;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
  padding: 20px 20px;
  box-sizing: border-box;
  margin-bottom: 16px;
  position: relative;
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    border-bottom: 1px solid #d9d9d9;
    .title-text {
      color: #2155b5;
      font-size: 18px;
      font-weight: bold;
      height: 36px;
      line-height: 36px;
      border-bottom: 3px solid #2155b5;
      padding: 0px 4px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.mt30 {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-item {
    display: flex;
    align-items: center;
    width: 50%;
    margin-bottom: 6px;
    .main-text-style {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #121212;
      margin-bottom: 0!important;
      width: 165px;
      text-align: right;
      padding-right: 10px;
      box-sizing: border-box;
    }
    .pl16 {
      width: calc(100%- 235px);
    }
    .form-item-right {
      width: 100%;
    }
    // .form-item-right {
    //   width: 240px;
    // }
  }
  .form-item-upload {
    display: flex;
    align-items: center;
    .main-text-style {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 0;
      width: 165px;
      text-align: right;
      padding-right: 10px;
      box-sizing: border-box;
    }
    .form-item-right {
      width: 240px;
    }
  }
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
  box-sizing: border-box;
}
.submit-btn.btn-bg-1 {
  background: #fff;
  color: #2155b5;
  border: 1px solid #2155b5;
}

.input-style-2 {
  width: 100%;
  padding: 6px 12px;
  height: 40px;
  font-size: 16px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
// /deep/ .ant-calendar-picker {
//   width: 50%;
// }
/deep/ .ant-input {
  width: 100%;
  padding: 6px 12px;
  height: 40px;
  font-size: 16px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.plflex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.text1 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin: 20px;
  width: 165px;
}
.mb15-item {
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.file-input-box {
  color: #2155b5;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155b5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
.percentage-text {
  width: 86%;
  padding: 6px 12px;
  height: 40px;
  font-size: 16px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.percentage-sign {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  // color: #999;
  margin: 14px 0 15px 10px;
  color: #e5914b;
  cursor: pointer;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>
